export default __webpack_public_path__ + "static/media/linkedin2.f09bd580.png";